import {
  RenderInPortal,
  RowSectionGrid,
  Z_INDEXES,
  gridCols,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useEffect, useState} from 'react';

const LOCAL_STORAGE_KEY = 'GRID_SYSTEM_OVERLAY';
const GRID_SYSTEM_CUSTOM_EVENT_NAME = 'GRID_SYSTEM_OVERLAY_CHANGE';

export const GridSystemOverlay: React.FC = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  const handleCustomEvent = (e: CustomEvent<{value: boolean}>) => {
    setShowOverlay(e.detail.value);
  };

  useEffect(() => {
    const isOverlayEnabled =
      window.localStorage.getItem(LOCAL_STORAGE_KEY) === 'true';
    // eslint-disable-next-line local-rules/set-state-in-use-effect
    setShowOverlay(isOverlayEnabled);

    window.addEventListener(
      GRID_SYSTEM_CUSTOM_EVENT_NAME,
      handleCustomEvent as EventListener,
    );

    return () => {
      window.removeEventListener(
        GRID_SYSTEM_CUSTOM_EVENT_NAME,
        handleCustomEvent as EventListener,
      );
    };
  }, []);

  if (!showOverlay) {
    return null;
  }

  return (
    <RenderInPortal portalId="grid-system-overlay-portal-host">
      <StyledRowSectionGrid>
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
        <Col />
      </StyledRowSectionGrid>
    </RenderInPortal>
  );
};

const StyledRowSectionGrid = styled(RowSectionGrid)`
  position: fixed;
  inset: 0;
  z-index: ${Z_INDEXES.GRID_SYSTEM_OVERLAY};
  pointer-events: none;
  justify-content: center;
`;

const Col = styled.div`
  ${gridCols(1)}
  background-color: #9747FF;
  opacity: 0.08;
  height: 100vh;
`;
